/* 🤖 this file was generated by svg-to-ts */
export const siriusShield: {
  name: 'shield';
  data: string;
} = {
  name: 'shield',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 3.75A1.5 1.5 0 0 0 3 5.25v5.503c0 8.39 7.123 11.166 8.52 11.63.31.112.65.112.96 0 1.397-.464 8.52-3.24 8.52-11.63V5.25a1.5 1.5 0 0 0-1.5-1.5h-15Zm8.25 1.5h6.75v5.503c0 6.362-4.666 9.045-6.75 9.925V5.25Zm-1.5 0H4.5v5.503c0 6.362 4.666 9.045 6.75 9.925V5.25Z" fill="currentColor"/></svg>`
};
